import {StatsStrategy} from "./statsStrategy";
import {getGameModeNameFromGameModeId} from "../../utils";
import {GameModes} from "../../constants/EnumGameModes";
import {StatsStrategyClassic} from "./strategy/StatsStrategyClassic";
import {StatsStrategyRace} from "./strategy/StatsStrategyRace";
import {StatsStrategyFastaily} from "./strategy/StatsStrategyFastaily";


export const getStatsStrategy = async (gameModeId: number): Promise<StatsStrategy> => {
    const gameMode = await getGameModeNameFromGameModeId(gameModeId);

    switch (gameMode) {
        case GameModes.RACE_SOLO:
            return new StatsStrategyRace();
        case GameModes.FASTAILY:
            return new StatsStrategyFastaily();
        case GameModes.CLASSIC_SOLO:
        default:
            return new StatsStrategyClassic();
    }
}
